import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=b27a44cc&scoped=true&"
var script = {}
import style0 from "./Ribbon.vue?vue&type=style&index=0&id=b27a44cc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b27a44cc",
  null
  
)

export default component.exports